import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import chartPreview from './venueExecCapsulePreview.png';
import backPreview from './venueExecCapsuleBackPreview.png';

export const venueExecCapsuleDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                This capsule analyses which execution venues a symbol typically
                trades in, today&apos;s breakdown and your order&apos;s
                execution venue usage.
            </div>
        </>
    ),
    minPreviewHeight: 180,
    previews: [
        {
            title: 'Chart',
            src: chartPreview,
            altText: 'venue-type-capsule-chart-preview',
        },
        {
            title: 'Back',
            src: backPreview,
            altText: 'venue-type-capsule-back-preview',
        },
    ],
};
